// @ts-nocheck
import { supabase } from "@/integrations/supabase/client";

export function useLoginAudit() {
  
  // Registrar login (sucesso ou falha)
  const logLogin = async (userId: string, status: 'success' | 'failed', failureReason?: string) => {
    try {
      console.log('📝 Audit: tentando registrar login...', { userId, status });
      
      const { data, error } = await supabase
        .from('session_audit')
        .insert({
          user_id: userId,
          status,
          failure_reason: failureReason,
          login_method: 'password',
          user_agent: navigator.userAgent,
          device_type: /mobile/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
        })
        .select('id')
        .single();
      
      if (error) {
        console.error('❌ Audit: erro ao registrar', error);
        throw error;
      }
      
      console.log('✅ Audit: login registrado', data);
      
      // Salvar ID da sessão no localStorage para posterior logout
      if (status === 'success' && data) {
        localStorage.setItem('current_audit_id', data.id);
      }
      
      return data;
    } catch (error) {
      console.error('❌ Audit: erro geral', error);
      // Não bloqueia o login se auditoria falhar
      return null;
    }
  };
  
  // Registrar logout normal
  const logLogout = async () => {
    try {
      const auditId = localStorage.getItem('current_audit_id');
      if (!auditId) return;
      
      await supabase
        .from('session_audit')
        .update({ 
          logout_at: new Date().toISOString(),
          status: 'success'
        })
        .eq('id', auditId);
      
      localStorage.removeItem('current_audit_id');
    } catch (error) {
      console.error('Error logging logout:', error);
    }
  };
  
  // Registrar logout forçado (ex: inatividade)
  const logForcedLogout = async (reason: string) => {
    try {
      const auditId = localStorage.getItem('current_audit_id');
      if (!auditId) return;
      
      await supabase
        .from('session_audit')
        .update({ 
          logout_at: new Date().toISOString(),
          status: 'forced_logout',
          failure_reason: reason
        })
        .eq('id', auditId);
      
      localStorage.removeItem('current_audit_id');
    } catch (error) {
      console.error('Error logging forced logout:', error);
    }
  };
  
  return { logLogin, logLogout, logForcedLogout };
}
